module.exports = __webpack_public_path__ + "assets/static/png/icon-tv.027d3e81d105d941b2b6307b3f702159.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/payments/images/icon-tv.png
 ** module id = 538
 ** module chunks = 1
 **/